import type { ReactNode } from 'react';
import styles from './ConfigCardSection.module.css';

interface ConfigCardSectionProps {
	title?: string;
	children: ReactNode;
}

export const ConfigCardSection = ({ title, children }: ConfigCardSectionProps) => {
	return (
		<section className={styles.section}>
			{title && <h2 className={styles.sectionTitle}>{title}</h2>}
			<div className={styles.scrollRow}>{children}</div>
		</section>
	);
};
